import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../component/Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteOrder,
  getPendingOrders,
  RESETORDER,
  selectOrder,
  selectOrderSuccessComplete,
  selectPendingOrders,
  updateOrderStatus,
} from "../../redux/features/order/OrderSlice";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import PreviewOrder from "../../component/Preview Order/PreviewOrder";
import { useNavigate } from "react-router-dom";
import {
  filterOrders,
  selectFilteredOrders,
} from "../../redux/features/filter/FilterSlice";
import { FiX } from "react-icons/fi";
import dayjs from "dayjs";
import KitchenPrint from "./kitchenPrint";
import UpdateOrder from "./UpdateOrder";
import { GiCheckMark } from "react-icons/gi";
import { AdminCashier } from "../../component/Protect/HiddenLink";
import ChangeTable from "./ChangeTable";
import FreeOrder from "./FreeOrder";
import { AdminCashierCounter } from "../../Protect/HiddenLink";

const CompletingOrder = () => {
  const dispatch = useDispatch();
  const pendingOrders = useSelector(selectPendingOrders);
  const filteredOrders = useSelector(selectFilteredOrders);
  const printOrder = useSelector(selectOrder);
  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [charged, setCharged] = useState();
  const [amountType, setAmountType] = useState("cash");
  const [orderAmount, setOrderAmount] = useState();
  const [order, setOrder] = useState();
  const [isLoadingComplete, setIsLoadingComplete] = useState(false);
  const [errors, setErrors] = useState({});
  const printRef = useRef();
  const isSuccess = useSelector(selectOrderSuccessComplete);

  const serviceCharges = process.env.REACT_APP_SERVICE_CHARGES;

  useEffect(() => {
    dispatch(getPendingOrders());
    const intervalId = setInterval(() => {
      dispatch(getPendingOrders());
      dispatch(RESETORDER());
    }, 10000);
    return () => clearInterval(intervalId);
  }, [dispatch]);

  const handleOpen = (order) => {
    setOrder(order);
    setOrderAmount(
      order?.totalAmountDiscount > 0
        ? order?.totalAmountAfterDiscount + order?.serviceCharges
        : order.totalAmount + order.serviceCharges
    );
    setCharged(
      order?.totalAmountDiscount > 0
        ? order?.totalAmountAfterDiscount + order?.serviceCharges
        : order.totalAmount + order.serviceCharges
    );
    setIsOpen(true);
  };

  const handleClose = () => {
    setOrder();
    setOrderAmount();
    setIsOpen(false);
    setErrors({});
    setAmountType("cash");
    setCharged();
  };

  const priceSymbol = process.env.REACT_APP_PRICE_SYMBOL;

  const validateForm = () => {
    const newErrors = {};
    if (!amountType) newErrors.amountType = "Amount Type is required";
    if (!charged) newErrors.charged = "Charged Amount is required";
    if (charged < orderAmount)
      newErrors.charged = `Minimum Charged Amount is ${priceSymbol} ${orderAmount}.`;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleComplete = async (e, order) => {
    e.preventDefault();
    if (validateForm()) {
      setIsLoadingComplete(true);
      const updateOrderData = {
        charged: Number(charged),
        amountType,
      };
      const id = order?._id;
      await dispatch(updateOrderStatus({ updateOrderData, id }));
      dispatch(getPendingOrders());
    }
  };

  const printStyles = `
  @media print {
    body {
      margin: 0;
      padding: 0;
      
    }
    html, body {
      height: auto;
      width: 100%;
      overflow: hidden;
    }
    * {
      page-break-inside: avoid;
    }
    @page {
      size: auto; 
      margin: 0;
    }
  }
`;

  const handlePrint = () => {
    const isMobile =
      /Mobi|Android/i.test(navigator.userAgent) || window.innerWidth < 768;
    if (isMobile) {
      return;
    }
    const printContent = printRef.current;
    if (!printContent) return;
    toast.dismiss();

    const styles = Array.from(document.styleSheets)
      .map((sheet) => {
        try {
          return Array.from(sheet.cssRules)
            .map((rule) => rule.cssText)
            .join("\n");
        } catch (err) {
          return "";
        }
      })
      .join("\n");

    const iframe = document.createElement("iframe");
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(`
      <html>
        <head>
          <title>Print PDF</title>
        <link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap" rel="stylesheet">
        <style>
          ${styles}  
                    ${printStyles}

          body {
            font-family: 'Inter'; 
            color: #000;
            font-weight: medium;
          }
            .text-[.8rem]{
            font-size: 12px;
           
            }
            .text-[.85rem]{
            font-size: 13.50px;
           
            }
            .text-[.7rem]{
            font-size: 11.2px;
            }
            .text-[.73rem]{
            font-size: 11.68px;
           
            }
            .text-[.6rem]{
            font-size: 9.6px;
            
            }
        </style>
        </head>
        <body >${printContent.innerHTML}</body>
      </html>
    `);
    doc.close();

    iframe.contentWindow.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    };
  };

  useEffect(() => {
    if (isSuccess) {
      setIsLoadingComplete(false);
      handleClose();
      handlePrint();
      dispatch(RESETORDER());
    } else {
      setIsLoadingComplete(false);
    }
  }, [isSuccess]);

  // confirm delete the order
  const confirmCancel = (id, orderNo) => {
    if (!id || !orderNo) {
      toast.error("ID or order no is undefined");
      return;
    }
    confirmAlert({
      title: "Delete This Order",
      message: `Are you sure to delete this #${orderNo}?`,
      buttons: [
        {
          label: "Delete",
          onClick: () => cancel(id),
        },
        {
          label: "Cancel",
        },
      ],
    });
  };

  const cancel = async (id) => {
    await dispatch(deleteOrder(id));
    dispatch(getPendingOrders());
    dispatch(RESETORDER());
  };
  const navigate = useNavigate();
  useEffect(() => {
    if (!pendingOrders) {
      navigate("/tableNo");
    }
  }, [navigate, pendingOrders]);

  useEffect(() => {
    dispatch(filterOrders({ search, pendingOrders }));
  }, [dispatch, search, pendingOrders]);

  return (
    <div className="flex flex-col h-screen bg-[#F1F1F1] ">
      <div>
        <Navbar page="Completing Orders" />
      </div>
      <div className="flex gap-4 md:px-8 px-4 py-4  overflow-y-auto scrollbar-hide">
        <div className="flex flex-col w-full mx-auto">
          <div className="flex lg:justify-end sm:justify-center justify-start my-4 items-center ">
            <input
              type="search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="bg-transparent py-2 px-4 md:border-2 border border-[#A9A9A9]  rounded-xl outline-none"
              placeholder="Search by order..."
            />
          </div>
          {filteredOrders && filteredOrders.length > 0 ? (
            <div className="md:w-full w-[35rem] mx-auto ">
              <div className="overflow-auto scrollbar-hide touch-auto border-none">
                <table className="w-full border border-gray-300">
                  <thead className="bg-gray-100">
                    <tr className="text-left text-gray-700 md:text-[1rem] text-[.7rem] ">
                      <th className="md:py-4 py-2 md:px-2 pl-1 border w-[18%]">
                        Order No
                      </th>
                      <th className="md:py-4 py-2 md:px-2 pl-1 border w-[15%]">
                        Table No
                      </th>
                      <th className="md:py-4 py-2 md:px-2 pl-1 border w-[20%]">
                        Order Taken By
                      </th>
                      <th className="md:py-4 py-2 md:px-2 pl-1 border w-[20%]">
                        Total Amount
                      </th>
                      <th className="md:py-4 py-2 md:px-2 pl-1 border w-[27%]">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredOrders.map((filteredOrder, i) => (
                      <tr
                        key={i}
                        className="border-b hover:bg-gray-50 md:text-[1rem] text-[.7rem]  "
                      >
                        <td className="lg:p-2 p-1 border">
                          #{filteredOrder.orderNo}
                        </td>
                        <td className="lg:p-2 p-1 border capitalize">
                          <span className="flex justify-between items-center">
                            {filteredOrder.tableNo}
                            <ChangeTable
                              tableNo={filteredOrder.tableNo}
                              orderId={filteredOrder?._id}
                            />
                          </span>
                        </td>
                        <td className="lg:p-2 p-1 border capitalize">
                          {filteredOrder.username}
                        </td>
                        <td className="lg:p-2 p-1 border">
                          {priceSymbol}:{" "}
                          {filteredOrder.totalAmountDiscount > 0
                            ? filteredOrder.totalAmountAfterDiscount +
                              filteredOrder?.serviceCharges
                            : filteredOrder.totalAmount +
                              filteredOrder?.serviceCharges}
                        </td>
                        <td className="lg:p-2 p-1 border flex items-center gap-2">
                          <UpdateOrder id={filteredOrder._id} />
                          <AdminCashierCounter>
                            <KitchenPrint id={filteredOrder._id} />
                          </AdminCashierCounter>
                          <PreviewOrder id={filteredOrder._id} />

                          <AdminCashierCounter>
                            <FreeOrder id={filteredOrder._id} />
                          </AdminCashierCounter>
                          <AdminCashierCounter>
                            <button
                              title="Complete Order"
                              onClick={() => handleOpen(filteredOrder)}
                              className="lg:px-3 px-2 py-2 bg-green-500 text-white rounded-xl hover:bg-green-600"
                            >
                              {/* Complete */}{" "}
                              <GiCheckMark className="lg:size-6 size-[1.1rem]" />
                            </button>
                          </AdminCashierCounter>
                          <AdminCashierCounter>
                            <button
                              title="Cancel Order"
                              onClick={() =>
                                confirmCancel(
                                  filteredOrder._id,
                                  filteredOrder.orderNo
                                )
                              }
                              className="lg:px-3 px-2 py-2 bg-red-500 text-white rounded-xl hover:bg-red-600"
                            >
                              <FiX className="lg:size-6 size-[1.1rem]" />
                            </button>
                          </AdminCashierCounter>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className="text-center p-4 text-gray-500">
              No pending orders
            </div>
          )}
        </div>
      </div>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white shadow-xl rounded-[10px] sm:w-[450px] w-[90%] mx-auto p-8 space-y-6">
            <div className="flex justify-between items-center border-b-2 border-[#DEDEDE] pb-2 mb-4">
              <h1 className="md:text-[1.2rem] text-[1rem] font-bold text-[#0D868C]">
                Complete Order
              </h1>
              <button type="button" onClick={handleClose}>
                <FiX className="md:size-7 size-5 text-[#0D868C]" />
              </button>
            </div>

            <form onSubmit={(e) => handleComplete(e, order)}>
              <p className="text-center w-full text-[1.5rem] font-semibold">
                {priceSymbol}: {orderAmount?.toFixed(2)}
              </p>
              <div className="mb-4 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Amount Type
                </label>
                <select
                  value={amountType}
                  onChange={(e) => setAmountType(e.target.value)}
                  className="w-full outline-none rounded-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C] capitalize"
                >
                  <option value="cash" className="capitalize">
                    Cash
                  </option>
                  <option value="card" className="capitalize">
                    Card
                  </option>
                  <option value="online" className="capitalize">
                    Online
                  </option>
                </select>
                {errors.amountType && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.amountType}
                  </p>
                )}
              </div>
              <div className="mb-6 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Charged Amount
                </label>
                <input
                  value={charged}
                  onChange={(e) => setCharged(e.target.value)}
                  type="number"
                  placeholder="1000,2000 etc."
                  className={`w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C] ${
                    amountType !== "cash"
                      ? "bg-gray-200 cursor-not-allowed"
                      : ""
                  }`}
                  disabled={amountType !== "cash"}
                />
                {errors.charged && (
                  <p className="text-red-500 text-sm mt-1">{errors.charged}</p>
                )}
              </div>
              {charged > orderAmount && amountType === "cash" && (
                <p>
                  Return Amount {priceSymbol}:{" "}
                  {(charged - orderAmount)?.toFixed(2)}
                </p>
              )}

              <div className="text-center mt-8">
                <button
                  type="submit"
                  className={`text-white bg-[#0D868C] md:w-[50%]  w-full py-3 rounded-full outline-none uppercase font-normal text-[1rem] ${
                    isLoadingComplete ? "cursor-not-allowed" : "cursor-pointer"
                  }`}
                >
                  {isLoadingComplete ? (
                    <div className="flex items-center justify-center">
                      <svg
                        className="mr-2 w-5 h-5 animate-spin text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                        ></path>
                      </svg>
                      Processing…
                    </div>
                  ) : (
                    "Complete Order"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="hidden invisible">
        <div ref={printRef} className="flex justify-center items-center ">
          <div className="bg-white mx-1 flex flex-col ">
            <div className="text-center mx-auto">
              {/* {companyLogo && <img src={companyLogo} alt="company logo" />}
               */}
              <h1 className="w-full text-[1rem] text-center uppercase tracking-[.1em] ">
                Restaurant Bill
              </h1>
            </div>

            <div className=" py-2  rounded-xl flex flex-col gap-1  ">
              {printOrder?.orderNo && (
                <h1 className="w-full text-[.8rem] my-2 text-center uppercase tracking-[.1em] ">
                  Invoice #{printOrder.orderNo}
                </h1>
              )}

              {/* Lower Top Section */}
              <div className="flex flex-col gap-1 border-y  border-[#000] py-1 px-1">
                <p className="text-black text-[10px] uppercase tracking-[.1em] ">
                  Waiter:{" "}
                  <span className="capitalize">{printOrder?.username}</span>
                </p>
                <p className="text-black text-[10px] uppercase tracking-[.1em] ">
                  Table No: {printOrder?.tableNo}
                </p>
              </div>

              {/* Middle Section */}
              <div className="border border-[#000]">
                <div
                  className={`flex items-center w-full  border-b border-[#000]`}
                >
                  <div className="flex items-center justify-between w-full text-black text-[.7rem]  tracking-[.1em]  ">
                    <p className="w-[30%]  text-center py-1">Qty</p>
                    <p className="w-[35%] border-x border-[#000] text-center py-1">
                      Rate
                    </p>
                    <p className="w-[35%]  text-center py-1">Total</p>
                  </div>
                </div>
                {printOrder?.products?.map((item, index) => (
                  <div
                    key={item._id}
                    className={`flex items-start w-full flex-col `}
                  >
                    <div className="flex flex-col flex-1 gap-1 pl-1">
                      <h2 className="text-black text-[.7rem]  uppercase tracking-[.1em] ">
                        {index + 1}. {item?.name}{" "}
                      </h2>
                      {item?.name?.includes("deal") && (
                        <h2 className="text-black text-[.6rem] uppercase tracking-[.1em] ">
                          {item?.description}{" "}
                        </h2>
                      )}
                    </div>
                    <div
                      className={`flex items-center justify-between w-full  ${
                        index !== printOrder?.products?.length - 1
                          ? "border-y"
                          : "border-t"
                      }  border-[#000] text-black text-[.7rem] uppercase tracking-[.1em]  `}
                    >
                      <p className="w-[30%] text-center ">{item?.quantity}</p>
                      <p className="w-[35%] border-x border-[#000] text-center">
                        {item?.price}
                      </p>
                      <p className="w-[35%] text-center ">
                        {item?.price * item?.quantity}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Upper Lower Section */}
              <div>
                <p className="flex flex-col justify-between items-center pb-2 pt-1 text-[.73rem]  border-t  border-[#000] ">
                  {printOrder?.serviceCharges > 0 && (
                    <div className="flex justify-between items-center w-full uppercase tracking-[.1em]  text-[.73rem]">
                      <span>
                        Service Charges{" "}
                        {printOrder?.serviceChargesPercentage
                          ? printOrder?.serviceChargesPercentage
                          : serviceCharges}
                        %
                      </span>
                      <span className="">
                        {priceSymbol} {printOrder?.serviceCharges?.toFixed(2)}
                      </span>
                    </div>
                  )}
                  {printOrder?.totalAmount && (
                    <div className="flex justify-between items-center w-full uppercase tracking-[.1em] font-medium text-[.8rem]">
                      <span className=" ">Total</span>
                      <span className="">
                        {priceSymbol}{" "}
                        {(
                          printOrder?.totalAmount + printOrder?.serviceCharges
                        ).toFixed(2)}
                      </span>
                    </div>
                  )}

                  {printOrder?.totalAmountDiscount > 0 && (
                    <div className="flex justify-between items-center text-[.73rem] w-full">
                      <span className="text-black uppercase tracking-[.1em] ">
                        Discount
                      </span>
                      <span className="text-black uppercase tracking-[.1em] ">
                        {priceSymbol}{" "}
                        {printOrder?.totalAmountDiscount.toFixed(2)}
                      </span>
                    </div>
                  )}

                  {printOrder?.totalAmountDiscount > 0 && (
                    <div className="flex justify-between items-center text-[.85rem] w-full border-t border-[#000]">
                      <span className="text-black uppercase tracking-[.1em] font-medium">
                        Grand Total
                      </span>
                      <span className="text-black uppercase tracking-[.1em] font-medium">
                        {priceSymbol}{" "}
                        {printOrder?.totalAmountDiscount > 0
                          ? (
                              printOrder?.totalAmountAfterDiscount +
                              printOrder?.serviceCharges
                            ).toFixed(2)
                          : (
                              printOrder?.totalAmount +
                              printOrder?.serviceCharges
                            ).toFixed(2)}
                      </span>
                    </div>
                  )}
                  {printOrder?.charged > 0 && (
                    <div className="flex flex-col w-full  ">
                      <div className="flex justify-between items-center uppercase tracking-[.1em]  w-full text-[.73rem]">
                        <span className="">{printOrder?.amountType}</span>
                        <span className="">
                          {priceSymbol} {printOrder?.charged?.toFixed(2)}
                        </span>
                      </div>

                      {printOrder?.amountType?.toLowerCase() === "cash" &&
                        printOrder?.returnAmount > 0 && (
                          <div className="flex justify-between items-center w-full uppercase tracking-[.1em]  text-[.73rem] border-t border-[#000]">
                            <span>Change</span>
                            <span>
                              {priceSymbol}{" "}
                              {printOrder?.returnAmount?.toFixed(2)}
                            </span>
                          </div>
                        )}
                    </div>
                  )}
                </p>
              </div>

              <div className="text-[.75rem]  uppercase tracking-widest  text-center">
                Thank You for Visiting
              </div>

              <div className="text-[.7rem] uppercase tracking-[.1em]  text-center w-full">
                Powered By Eastern Tech
                {/* <img src={ETLogo} alt="" /> */}
              </div>
              {/* Lower Section */}
              <div className="flex justify-center items-center text-black  text-[14px] uppercase tracking-[.1em]  pb-6">
                <p>
                  {dayjs(printOrder?.createdAt).format("D /M /YYYY . h:mm A")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompletingOrder;
